import React from "react";
import moment from "moment";
import "moment/locale/ru";
import { useTranslation } from "react-i18next";
import style from "./ExpeditorActionsTab.module.scss";
import ClockIcon from "../../../../../../shared/icons/ClockIcon";
import CheckIcon from "../../../../../../shared/icons/CheckIcon";

const formatDateTime = (value) => {
  if (!value) return "";
  return moment(value).locale("ru").format("DD.MM.YYYY, HH:mm");
};

const ExpeditorFinalStatusInfo = ({ order }) => {
  const { t } = useTranslation();
  const status = String(order?.status || "").toLowerCase();

  if (status === "delivered") {
    const senderCompanyName =
      order?.companyName || "";

    return (
      <div className={style.info_card}>
        <div className={`${style.info_icon_circle} ${style.info_icon_warning}`}>
          <ClockIcon type={2} fill="#FF9800" />
        </div>
        <div className={style.info_text_group}>
          <span className={style.info_title_secondary}>
            {t("orderInfoExpeditor.actions.shipperChecksDocuments", {
              company: senderCompanyName,
            })}
          </span>
          <span className={style.info_subtitle}>
            <span className={style.info_subtitle_strong}>
              {t("orderInfoExpeditor.actions.averageTime")}{" "}
            </span>
            <span className={style.info_subtitle_accent}>
              {t("orderInfoExpeditor.actions.averageTimeValue")}
            </span>
          </span>
        </div>
      </div>
    );
  }

  if (status === "completed") {
    return (
      <div className={style.info_card}>
        <div className={`${style.info_icon_circle} ${style.info_icon_success}`}>
          <CheckIcon color="#ffffff" width="72px" height="78px" />
        </div>
        <div className={style.info_text_group}>
          <span className={style.info_title_primary}>
            {t("orderInfoExpeditor.actions.orderCompleted")}
          </span>
          <span className={style.info_subtitle}>
            {t("orderInfoExpeditor.actions.partnerAcceptedAt", {
              date: formatDateTime(order?.updatedAt),
            })}
          </span>
        </div>
      </div>
    );
  }

  return null;
};

export default ExpeditorFinalStatusInfo;

